import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Modal, Button, Form, Badge } from "react-bootstrap";
import { FiPlus, FiEdit2, FiUserPlus } from "react-icons/fi";
import api, { parseWIB } from "../services/api";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({
    username: "",
    full_name: "",
    password: "",
    role: "kasir",
  });

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const res = await api.get("/auth/users");
      setUsers(res.data);
    } catch (error) {
      toast.error("Gagal memuat data user");
    }
  };

  const handleSubmit = async () => {
    if (!form.full_name || !form.username) {
      toast.error("Nama dan username wajib diisi");
      return;
    }
    if (!editItem && !form.password) {
      toast.error("Password wajib diisi");
      return;
    }
    try {
      if (editItem) {
        const payload = {
          full_name: form.full_name,
          role: form.role,
          is_active: editItem.is_active,
        };
        if (form.password) payload.password = form.password;
        await api.put(`/auth/users/${editItem.id}`, payload);
        toast.success("User berhasil diupdate");
      } else {
        await api.post("/auth/users", form);
        toast.success("User berhasil ditambahkan");
      }
      setShowModal(false);
      setEditItem(null);
      setForm({ username: "", full_name: "", password: "", role: "kasir" });
      loadUsers();
    } catch (error) {
      toast.error(error.response?.data?.message || "Gagal menyimpan");
    }
  };

  const handleEdit = (u) => {
    setEditItem(u);
    setForm({
      username: u.username,
      full_name: u.full_name,
      password: "",
      role: u.role,
    });
    setShowModal(true);
  };

  const toggleActive = async (u) => {
    try {
      await api.put(`/auth/users/${u.id}`, {
        full_name: u.full_name,
        role: u.role,
        is_active: u.is_active ? 0 : 1,
      });
      toast.success(u.is_active ? "User dinonaktifkan" : "User diaktifkan");
      loadUsers();
    } catch (error) {
      toast.error("Gagal mengubah status");
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">Manajemen User</h4>
        <button
          className="btn btn-primary"
          onClick={() => {
            setEditItem(null);
            setForm({
              username: "",
              full_name: "",
              password: "",
              role: "kasir",
            });
            setShowModal(true);
          }}
        >
          <FiUserPlus className="me-1" /> Tambah User
        </button>
      </div>

      <div className="card">
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead>
              <tr>
                <th>Nama Lengkap</th>
                <th>Username</th>
                <th>Role</th>
                <th>Status</th>
                <th>Dibuat</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className={!u.is_active ? "text-muted" : ""}>
                  <td className="fw-bold">{u.full_name}</td>
                  <td>{u.username}</td>
                  <td>
                    <Badge bg={u.role === "admin" ? "danger" : "info"}>
                      {u.role.toUpperCase()}
                    </Badge>
                  </td>
                  <td>
                    <span
                      className={`badge ${u.is_active ? "bg-success" : "bg-secondary"}`}
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleActive(u)}
                    >
                      {u.is_active ? "Aktif" : "Nonaktif"}
                    </span>
                  </td>
                  <td>{parseWIB(u.created_at).toLocaleDateString("id-ID")}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => handleEdit(u)}
                    >
                      <FiEdit2 size={14} />
                    </button>
                  </td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center text-muted py-4">
                    Belum ada data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editItem ? "Edit User" : "Tambah User"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Nama Lengkap *</Form.Label>
            <Form.Control
              value={form.full_name}
              onChange={(e) => setForm({ ...form, full_name: e.target.value })}
              placeholder="Nama lengkap"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Username *</Form.Label>
            <Form.Control
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              placeholder="Username untuk login"
              disabled={!!editItem}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              Password {editItem ? "(kosongkan jika tidak diubah)" : "*"}
            </Form.Label>
            <Form.Control
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder={
                editItem ? "Kosongkan jika tidak diubah" : "Password"
              }
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Role</Form.Label>
            <Form.Select
              value={form.role}
              onChange={(e) => setForm({ ...form, role: e.target.value })}
            >
              <option value="kasir">Kasir</option>
              <option value="admin">Admin</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Batal
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Simpan
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Users;
